import type { TradeInAemVehicleValuationType, TradeInAemVehicleValueResponseType } from "../../utils/types";
import {
    TRADE_IN_AEM_RESET_QUOTE,
    type TradeInAemVehicleValueActions,
    TRADE_IN_AEM_SET_LATEST_RESPONSE,
    TRADE_IN_AEM_SET_QUOTE,
    TRADE_IN_AEM_SET_QUOTE_FAILED,
    TRADE_IN_AEM_SET_VALUE_FETCHING,
} from "../actions/TradeInAemVehicleValueActions";

export type TradeInAemVehicleValueReducerType = {
    fetching: boolean;
    failed: boolean; // Dont forget to reset this when going back to vehicle details
    valuation: TradeInAemVehicleValuationType | null;
    latestResponse: TradeInAemVehicleValueResponseType;
};

export const initialStateTradeInAemVehicleValue: TradeInAemVehicleValueReducerType = {
    fetching: false,
    failed: false,
    valuation: null,
    latestResponse: null,
};

const TradeInAemVehicleValueReducer = (
    state: TradeInAemVehicleValueReducerType = initialStateTradeInAemVehicleValue,
    action: TradeInAemVehicleValueActions,
): TradeInAemVehicleValueReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_SET_VALUE_FETCHING:
            return { ...state, fetching: action.fetching };

        case TRADE_IN_AEM_SET_QUOTE:
            return { ...state, valuation: action.quote, fetching: false };

        case TRADE_IN_AEM_SET_QUOTE_FAILED:
            return { ...state, failed: action.failed, fetching: false };

        case TRADE_IN_AEM_SET_LATEST_RESPONSE:
            return { ...state, latestResponse: action.latestResponse };

        case TRADE_IN_AEM_RESET_QUOTE:
            return { ...state, valuation: null, failed: false };

        default:
            return state;
    }
};

export default TradeInAemVehicleValueReducer;
